























import {Component, Vue} from 'vue-property-decorator';
import {ErrorAlertModule} from "@/store/modules/errors";

@Component({
  data: () => ({}),
})
export default class ErrorAlert extends Vue {

  get errorAlert() {
    return ErrorAlertModule.errorAlert;
  }
  get isErrorXml() {
    return ErrorAlertModule.isErrorXml;
  }

}
